import React from 'react';
import { TableContainer, Table, Thead, Tr, Th } from '@chakra-ui/react';
import { localise } from '../../../services/lang/lang';
import useStyling from '../../../hooks/useStyling';
import ResultTableBody from '../ResultTableBody/ResultTableBody';
import RemoteSubmissionInvitesTableRow from './RemoteSubmissionInvitesTableRow';
import Pagination from '../Pagination/Pagination';
const headers = [localise('NAME'), localise('EMAIL'), localise('SENT')];
const RemoteSubmissionInvitesTable = ({ invites, onMutated, pagination, isFetching, onInviteResent, }) => {
    const styling = useStyling();
    const headerCount = headers.length + 1;
    return (React.createElement(TableContainer, { "data-testid": "remote_submission_invites_table", sx: styling.tableContainer.card },
        React.createElement(Table, { cursor: "default", variant: "rounded" },
            React.createElement(Thead, { position: "sticky", top: "0", zIndex: "1" },
                React.createElement(Tr, null,
                    React.createElement(Th, { "aria-label": localise('INVITE_ACTIONS'), w: "56px" }),
                    headers.map((header) => (React.createElement(Th, { key: header }, header))))),
            React.createElement(ResultTableBody, { isFetching: isFetching, colCount: headerCount, sx: styling.tableBody.noHover, mainText: localise('NO_INVITES') }, invites?.map((invite) => (React.createElement(RemoteSubmissionInvitesTableRow, { key: invite.id, invite: invite, onMutated: onMutated, onInviteResent: onInviteResent }))))),
        pagination && React.createElement(Pagination, { meta: pagination, isFetching: isFetching })));
};
export default RemoteSubmissionInvitesTable;
